import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import React from "react";
import { flatMap, isString, pick } from "lodash-es";
import versionHistoryTool from "./versionHistoryTool";
import MenuBar from "../MenuBar";
import "./style.css";
import { Button } from "@blueprintjs/core";
import downloadTool from "./downloadTool";
import importTool from "./importTool";
import cutsiteTool from "./cutsiteTool";
import featureTool from "./featureTool";
import partTool from "./partTool";
import oligoTool from "./oligoTool";
import orfTool from "./orfTool";
import editTool from "./editTool";
import findTool from "./findTool";
import inlineFindTool from "./inlineFindTool";
import alignmentTool from "./alignmentTool";
import saveTool from "./saveTool";
import visibilityTool from "./visibilityTool";
import undoTool from "./undoTool";
import redoTool from "./redoTool";
import collabTool from "./collabTool";
import isMobile from "is-mobile";
import { useMemo } from "react";
import { tabHeight } from "../constants";
const allTools = {
  downloadTool,
  importTool,
  cutsiteTool,
  alignmentTool,
  featureTool,
  partTool,
  oligoTool,
  orfTool,
  editTool,
  findTool,
  inlineFindTool,
  versionHistoryTool,
  collabTool,
  saveTool,
  visibilityTool,
  undoTool,
  redoTool
};
export function ToolBar(props) {
  const {
    modifyTools,
    contentLeft,
    showMenuBar,
    displayMenuBarAboveTools,
    isProtein,
    openHotkeyDialog,
    onSave,
    userDefinedHandlersAndOpts,
    editorName,
    annotationsToSupport,
    handleFullscreenClose,
    closeFullscreen,
    additionalTopRightToolbarButtons,
    toolList = defaultToolList,
    ...rest
  } = props;
  const userDefinedProps = {
    ...pick(props, userDefinedHandlersAndOpts)
  };
  const toolListToUse = useMemo(() => {
    return flatMap(toolList, (toolNameOrOverrides) => {
      let toolName;
      let toolOverride;
      if (isString(toolNameOrOverrides)) {
        toolName = toolNameOrOverrides;
      } else {
        toolOverride = toolNameOrOverrides;
        toolName = toolNameOrOverrides.name;
      }
      if (toolName === "oligoTool" && annotationsToSupport && annotationsToSupport.primers === false)
        return [];
      const Tool = toolOverride ? allTools[toolOverride.name] : allTools[toolName];
      if (!Tool) {
        console.error(
          "You're trying to load a tool that doesn't appear to exist: " + toolName
        );
        return [];
      }
      if (isProtein) {
        if (toolName === "cutsiteTool" || toolName === "orfTool" || toolName === "alignmentTool") {
          return [];
        }
      }
      if (toolName === "saveTool" && !onSave) {
        return [];
      }
      return { toolName, toolOverride, Tool };
    });
  }, [toolList, annotationsToSupport, isProtein, onSave]);
  let items = flatMap(
    toolListToUse,
    ({ toolName, toolOverride, Tool }, index) => {
      if (!Tool) return [];
      return /* @__PURE__ */ createElement(
        Tool,
        {
          ...rest,
          ...userDefinedProps,
          toolbarItemProps: {
            ...userDefinedProps,
            index,
            toolName,
            editorName,
            ...toolOverride
          },
          editorName,
          key: toolName
        }
      );
    }
  );
  if (modifyTools) {
    items = modifyTools(items);
  }
  return /* @__PURE__ */ jsxs("div", { className: "veToolbar-outer", style: { display: "flex" }, children: [
    contentLeft,
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          ...displayMenuBarAboveTools && showMenuBar ? {
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "flex-start"
          } : {
            display: "flex",
            width: "100%",
            justifyContent: "center",
            flexWrap: "wrap"
          }
        },
        className: "veToolbar",
        children: [
          showMenuBar && /* @__PURE__ */ jsx(
            MenuBar,
            {
              openHotkeyDialog,
              ...userDefinedProps,
              onSave,
              style: { marginLeft: 0 },
              editorName
            }
          ),
          displayMenuBarAboveTools && showMenuBar ? /* @__PURE__ */ jsx(
            "div",
            {
              className: "veTools-displayMenuBarAboveTools",
              style: {
                display: "flex",
                paddingLeft: 15,
                paddingRight: 15,
                flexWrap: "wrap",
                ...isMobile() && {
                  overflow: "auto",
                  flexWrap: "nowrap",
                  width: "100%"
                }
                // width: "100%"
              },
              children: items
            }
          ) : items
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { style: { height: tabHeight, display: "flex" }, children: [
      additionalTopRightToolbarButtons,
      closeFullscreen && /* @__PURE__ */ jsx(CloseFullscreenButton, { onClick: handleFullscreenClose })
    ] })
  ] });
}
const CloseFullscreenButton = (props) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      "data-tip": "Close Fullscreen Mode",
      minimal: true,
      intent: "primary",
      style: {
        marginTop: 2,
        marginRight: 2
      },
      onClick: props.onClick,
      className: "ve-close-fullscreen-button",
      icon: "minimize"
    }
  );
};
export const defaultToolList = [
  "saveTool",
  "downloadTool",
  "importTool",
  "undoTool",
  "redoTool",
  "versionHistoryTool",
  "collabTool",
  "cutsiteTool",
  "featureTool",
  "partTool",
  "oligoTool",
  "orfTool",
  "alignmentTool",
  "editTool",
  "findTool",
  "visibilityTool"
];
